import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=c3ebb5c0&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ebb5c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3ebb5c0')) {
      api.createRecord('c3ebb5c0', component.options)
    } else {
      api.reload('c3ebb5c0', component.options)
    }
    module.hot.accept("./index2.vue?vue&type=template&id=c3ebb5c0&scoped=true", function () {
      api.rerender('c3ebb5c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/index2.vue"
export default component.exports